var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStructure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 20,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "iconTitle"
  }, "Distributor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "iconTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    id: "Structure",
    d: "M62,41h-6v-9c0-0.5527992-0.4472809-1-1-1H33v-8h6c1.1044998,0,2-0.8955002,2-2V7c0-1.1046-0.8955002-2-2-2H25 c-1.104599,0-2,0.8954-2,2v14c0,1.1044998,0.895401,2,2,2h6v8h-22c-0.5528002,0-1,0.4472008-1,1v9h-6 c-1.1046,0-1.9999999,0.895401-1.9999999,2v14c0,1.1044998,0.8953999,2,1.9999999,2H16c1.1044998,0,2-0.8955002,2-2V43 c0-1.104599-0.8955002-2-2-2h-5.999999v-8h21v8h-6c-1.104599,0-2,0.895401-2,2v14c0,1.1044998,0.895401,2,2,2h14 c1.1044998,0,2-0.8955002,2-2V43c0-1.104599-0.8955002-2-2-2h-6v-8h21v8h-6c-1.104599,0-2,0.895401-2,2v14 c0,1.1044998,0.895401,2,2,2h14c1.1044998,0,2-0.8955002,2-2V43C64,41.895401,63.1044998,41,62,41z M25,7h14v14H25V7z M16,43v14 H2.0000007V43H16z M39,57H25V43h14V57z M62,57H48V43h14V57z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructure);
export default __webpack_public_path__ + "static/media/structure.1d6342ba36b14302ed6b0898c141eff0.svg";
export { ForwardRef as ReactComponent };